import React, { useContext, useState } from "react";
import { FaEdit, FaTrash } from "react-icons/fa";
import useAxios from "../common/hook/useAxios";
import { toast } from "react-toastify";
import { AuthContext } from "../context/AuthContext";
import Button from "./Button";
import { formatDateForInput, parseDateString } from "../constant";

const PatDashInsTable = ({
  selectedInsurance,
  handlePatEligibilityDetails,
  patientId,
  checkEligibility,
  DOSDate,
  setDOSDate,
}) => {
  const { request } = useAxios();
  const { user } = useContext(AuthContext);
  const [editingIndex, setEditingIndex] = useState(null);
  const [updatedDetails, setUpdatedDetails] = useState({});
  const [error, setError] = useState("");
  const [fromDate, setFromDate] = useState(new Date());
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());

  const markInsuranceInactive = (item) => {
    // console.log(item);
    const url = `${process.env.REACT_APP_PATIENT_PORTAL_URL}/PatientInsuranceDetails/MarkInsuraceInactive`;
    const requestBody = {
      objIns: {
        PatientID: patientId,
        InsCoID: item?.InsCoID,
        InsTblID: item?.InsTblID,
        insPolicyNumber: item?.InsPolicyNumber,
      },

      objUser: {
        practiceId: user?.PracticeID,
        roleID: 4,
        userId: user?.userId,
      },
    };
    request(url, {
      headers: {
        Authorization: `Bearer ${user.AuthToken}`,
        "Content-Type": "application/json",
      },
      method: "POST",
      data: JSON.stringify(JSON.stringify(requestBody)),
    })
      .then(() => {
        toast.success("Insurance marked inactive");
      })
      .catch(() => {
        toast.error("Error occurred while marking insuranc einactive", {
          autoClose: 3000,
        });
      });
  };

  const handleEditClick = async (index, item) => {
    setEditingIndex(index);
    setUpdatedDetails(item);
    // await handleInputChange("InsTblID", item?.InsTblID)
  };

  const handleInputChange = (field, value) => {
    setUpdatedDetails((prev) => ({ ...prev, [field]: value })); // Update specific field
  };

  const handleSaveClick = () => {
    const url = `${process.env.REACT_APP_PATIENT_PORTAL_URL}/PatientInsuranceDetails/UpdateInsurance`;
    const startDate = updatedDetails?.StartDate
      ? new Date(updatedDetails.StartDate).toLocaleDateString("en-GB")
      : null;
    const endDate = updatedDetails?.EndDate
      ? new Date(updatedDetails.EndDate).toLocaleDateString("en-GB")
      : null;
    const requestBody = {
      objUser: {
        practiceID: user?.PracticeID,
        roleID: 4,
        userId: user?.userId,
      },
      objIns: {
        PatientID: patientId,
        InsTblID: updatedDetails?.InsTblID,
        InsPolicyName: updatedDetails?.InsPolicyName,
        StartDate: startDate,
        EndDate: endDate,
        InsPolicyNumber: updatedDetails?.InsPolicyNumber,
        InsType: updatedDetails?.InsType,
      },
    };
    request(url, {
      headers: {
        Authorization: `Bearer ${user.AuthToken}`,
        "Content-Type": "application/json",
      },
      method: "POST",
      data: JSON.stringify(JSON.stringify(requestBody)),
    })
      .then(() => {
        toast.success("Insurance Updated Successfully");
        setEditingIndex(null); // Exit editing mode
      })
      .catch(() => {
        toast.error("Error occurred while updating insurance", {
          autoClose: 3000,
        });
      });
  };

  return (
    <table>
      <thead>
        <tr className="bg-blue-400 border-b text-white">
          <th style={{ whiteSpace: "nowrap" }} className="p-2 border-r">
            #
          </th>
          <th style={{ whiteSpace: "nowrap" }} className="p-2 border-r">
            Ins Type
          </th>
          <th style={{ whiteSpace: "nowrap" }} className="p-2 border-r">
            Ins Company
          </th>
          <th style={{ whiteSpace: "nowrap" }} className="p-2 border-r">
            Policy Number
          </th>
          <th style={{ whiteSpace: "nowrap" }} className="p-2 border-r">
            Start Date
          </th>
          <th style={{ whiteSpace: "nowrap" }} className="p-2 border-r">
            End Date
          </th>
          <th style={{ whiteSpace: "nowrap" }} className="p-2 border-r">
            DOS
          </th>
          <th style={{ whiteSpace: "nowrap" }} className="p-2 border-r">
            Eligibility
          </th>
          <th style={{ whiteSpace: "nowrap" }} className="p-2 border-r">
            Checked By
          </th>
          <th style={{ whiteSpace: "nowrap" }} className="p-2 border-r">
            Plan Name
          </th>
          <th style={{ whiteSpace: "nowrap" }} className="p-2 border-r">
            Relation
          </th>
          <th style={{ whiteSpace: "nowrap" }} className="p-2 border-r">
            Edit / Delete
          </th>
        </tr>
      </thead>
      <tbody>
        {/* <tr key={"unique-data"} className="border-b bg-blue-100">
          <td style={{ whiteSpace: "nowrap" }} className="p-2 border-r">
      
          </td>
          <td style={{ whiteSpace: "nowrap" }} className="p-2 border-r">
       
          </td>
          <td style={{ whiteSpace: "nowrap" }} className="p-2 border-r">
            <input
              type="search"
              className="py-1 px-2 border border-gray-400 rounded-md w-full my-1"
            />
          </td>
          <td style={{ whiteSpace: "nowrap" }} className="p-2 border-r">
            <input
              type="text"
              className="py-1 px-2 border border-gray-400 rounded-md w-full my-1"
            />
          </td>
          <td style={{ whiteSpace: "nowrap" }} className="p-2 border-r">
            <input
              type="date"
              id="from-date"
              value={formatDateForInput(fromDate)}
              onChange={(e) => {
                const dateString = e.target.value;
                const newDate = parseDateString(dateString);
                if (newDate) {
                  setFromDate(newDate); // Update the state with Date object
                  setError(""); // Clear any previous errors
                } else {
                  setError("Invalid date format.");
                }
              }}
              className="mt-1 block w-[200px] px-3 py-2 border border-gray-600 rounded-md bg-white text-black shadow-sm focus:outline-none focus:ring focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
            />
          </td>
          <td style={{ whiteSpace: "nowrap" }} className="p-2 border-r">
            <input
              type="date"
              id="from-date"
              value={formatDateForInput(fromDate)}
              onChange={(e) => {
                const dateString = e.target.value;
                const newDate = parseDateString(dateString);
                if (newDate) {
                  setFromDate(newDate); // Update the state with Date object
                  setError(""); // Clear any previous errors
                } else {
                  setError("Invalid date format.");
                }
              }}
              className="mt-1 block w-[200px] px-3 py-2 border border-gray-600 rounded-md bg-white text-black shadow-sm focus:outline-none focus:ring focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
            />
          </td>
          <td style={{ whiteSpace: "nowrap" }} className="p-2 border-r"></td>
          <td style={{ whiteSpace: "nowrap" }} className="p-2 border-r"></td>
          <td style={{ whiteSpace: "nowrap" }} className="p-2 border-r"></td>
          <td style={{ whiteSpace: "nowrap" }} className="p-2 border-r">
            <input
              type="text"
              className="py-1 px-2 border border-gray-400 rounded-md w-full my-1"
            />
          </td>
          <td style={{ whiteSpace: "nowrap" }} className="p-2 border-r">
            Relation
          </td>
          <td style={{ whiteSpace: "nowrap" }} className="p-2 border-r">
          </td>
        </tr> */}
        {Array.isArray(selectedInsurance) && selectedInsurance?.length > 0 ? (
          selectedInsurance.map((item, index) => {
            const endDate = item?.EndDate ? new Date(item.EndDate) : new Date();
            const startDate = item?.StartDate
              ? new Date(item.StartDate)
              : new Date();
            const date = new Date(item?.EligibilityDOS);
            const validDate = !isNaN(date) ? formatDateForInput(date) : formatDateForInput(DOSDate);

            return (
              <tr
                key={index}
              className={`border-b cursor-pointer ${item?.PatientInsStatus === "active" ? 'bg-white' : 'bg-pinkishRed'}`}
                onClick={() => handlePatEligibilityDetails(item)}
              >
                <td style={{ whiteSpace: "nowrap" }} className="p-2 border-r">
                  {index + 1}
                </td>
                <td style={{ whiteSpace: "nowrap" }} className="p-2 border-r">
                  {editingIndex === index ? (
                    <select
                      value={updatedDetails.InsType}
                      onChange={(e) =>
                        handleInputChange("InsType", e.target.value)
                      }
                    >
                      <option value="1">Primary</option>
                      <option value="2">Secondary</option>
                    </select>
                  ) : item?.InsType === "1" ? (
                    "Primary"
                  ) : (
                    "Secondary"
                  )}
                </td>
                <td style={{ whiteSpace: "nowrap" }} className="p-2 border-r">
               {item?.InsCoName} <br></br> (T-{item?.PayerID}, O-{item?.OptumPayerID})
                </td>
                <td style={{ whiteSpace: "nowrap" }} className="p-2 border-r">
                  {editingIndex === index ? (
                    <input
                      type="text"
                      value={updatedDetails.InsPolicyNumber}
                      onChange={(e) =>
                        handleInputChange("InsPolicyNumber", e.target.value)
                      }
                      className="py-1 px-2 border border-gray-400 rounded-md w-full my-1"
                    />
                  ) : (
                    item?.InsPolicyNumber
                  )} <br></br>
                  <Button
                    title="Mark as Inactive"
                    onClick={() => {
                      markInsuranceInactive(item);
                    }}
                  />
                </td>
                <td style={{ whiteSpace: "nowrap" }} className="p-2 border-r">
                  {editingIndex === index ? (
                    <input
                      type="date"
                      id="from-date"
                      value={formatDateForInput(startDate)}
                      onChange={(e) => {
                        const dateString = e.target.value;
                        const newDate = parseDateString(dateString);
                        if (newDate) {
                          setStartDate(newDate); // Update the state with Date object
                          setError(""); // Clear any previous errors
                        } else {
                          setError("Invalid date format.");
                        }
                      }}
                      className="mt-1 block w-[200px] px-3 py-2 border border-gray-600 rounded-md bg-white text-black shadow-sm focus:outline-none focus:ring focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                    />
                  ) : (
                    startDate?.toLocaleDateString("en-GB")
                  )}
                </td>
                <td style={{ whiteSpace: "nowrap" }} className="p-2 border-r">
                  {editingIndex === index ? (
                    <input
                      type="date"
                      id="from-date"
                      value={formatDateForInput(endDate)}
                      onChange={(e) => {
                        const dateString = e.target.value;
                        const newDate = parseDateString(dateString);
                        if (newDate) {
                          setEndDate(newDate); // Update the state with Date object
                          setError(""); // Clear any previous errors
                        } else {
                          setError("Invalid date format.");
                        }
                      }}
                      className="mt-1 block w-[200px] px-3 py-2 border border-gray-600 rounded-md bg-white text-black shadow-sm focus:outline-none focus:ring focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                    />
                  ) : (
                    endDate?.toLocaleDateString("en-GB")
                  )}
                </td>
                <td style={{ whiteSpace: "nowrap" }} className="p-2 border-r">
                  <input
                    type="date"
                    id="from-date"
                    value={
                      validDate
                    }
                    onChange={(e) => {
                      const dateString = e.target.value;
                      const newDate = parseDateString(dateString);
                      if (newDate) {
                        setDOSDate(newDate);
                        setError("");
                      } else {
                        setError("Invalid date format.");
                      }
                    }}
                    className="my-1 block w-[200px] px-3 py-2 border border-gray-600 rounded-md bg-white text-black shadow-sm focus:outline-none focus:ring focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                  />
                  <Button
                    title="Check"
                    onClick={() => {
                      checkEligibility(item);
                    }}
                  />
                </td>
                <td style={{ whiteSpace: "nowrap" }} className="p-2 border-r">
                  {item?.InsStatus}
                </td>
                <td style={{ whiteSpace: "nowrap" }} className="p-2 border-r">
                  {item?.EligibilityCheckedBy}
                </td>
                <td style={{ whiteSpace: "nowrap" }} className="p-2 border-r">
                  {item?.InsPolicyName}
                </td>
                <td style={{ whiteSpace: "nowrap" }} className="p-2 border-r">
                  {item?.InsuredRelation}
                </td>
                <td className="flex flex-row gap-2 items-center justify-center mt-5">
                  {editingIndex === index ? (
                    <Button title="Save" onClick={handleSaveClick} />
                  ) : (
                    <>
                      <FaEdit onClick={() => handleEditClick(index, item)} />
                      {/* <FaTrash onClick={() => markInsuranceInactive(item)} /> */}
                    </>
                  )}
                </td>
              </tr>
            );
          })
        ) : (
          <tr>
            <td colSpan="12" className="p-1">
              No insurance found for this patient
            </td>
          </tr>
        )}
      </tbody>
    </table>
  );
};

export default PatDashInsTable;
